import { AppDispatch } from "../../../slices/store";
import { scrollToTop } from "../../../utils/helpers/helperMethods/scrollToTop";
import {
  createJob,
  deleteJob,
  Job,
  jobsGet,
  updateJob,
} from "../../../slices/jobs/jobManagementSlice";
import { IProtectedResources } from "../../../hooks/constants";

export const handleDeleteJobService = (
  data: any,
  reqRequests: any,
  setIsLoading: any,
  dispatch: AppDispatch,
  addAlert: Function,
  shouldRedirect: boolean,
  navigate: Function,
  jobsGet: any,
  protectedResources: IProtectedResources
) => {
  const params = {
    id: data.id,
    accessToken: localStorage.getItem("AccessToken") || "llll",
    url: protectedResources.apiTodoList.endpoint + "/jobs/" + data.id,
  };

  dispatch(deleteJob(params)).then((r: any) => {
    setIsLoading(true);
    scrollToTop();
    if (r.payload.success === true) {
      addAlert("Job Deleted Successfully", "success", true);
      dispatch(jobsGet(reqRequests)).then((r: any) => {
        if (r.payload.succeeded) {
          setIsLoading(false);
          if (shouldRedirect) {
            navigate(-1);
          }
        }
      });
    } else {
      addAlert("Job Deleted Failed", "failed", true);
    }
  });
};

export const handleCreateJobService = (
  values: any,
  navigate: Function,
  dispatch: AppDispatch,
  jobRequests: any,
  setIsLoading: any,
  addAlert: Function,
  protectedResources: any
) => {
  setIsLoading(true);

  const requestParams = {
    job: {
      name: values.jobName,
      criteria: values.jobCriteria,
      startDate: values.startDate,
      endDate: values.endDate,
      state: 1,
      customerId: Number(values.client.value),
    },
    accessToken: localStorage.getItem("AccessToken") || "",
    url: protectedResources.apiTodoList.endpoint + "/jobs",
  };

  dispatch(createJob(requestParams)).then((res: any) => {
    if (res?.payload) {
      dispatch(jobsGet(jobRequests)).then(() => {
        setIsLoading(false);
        addAlert("Job Created Successfully", "success", true);
        navigate("/jobs");
      });
    } else {
      setIsLoading(false);
      addAlert("Job Creation Failed", "error", true);
    }
  });
};

export const handleEditJobService = (
  values: any,
  navigate: Function,
  dispatch: AppDispatch,
  jobRequests: any,
  setIsLoading: any,
  addAlert: Function,
  id: number,
  protectedResources: any
) => {
  const requestParams: { job: Job; accessToken: string; url: string } = {
    job: {
      id: id,
      name: values.jobName,
      criteria: values.jobCriteria,
      startDate: values.startDate,
      endDate: values.endDate,
      state: 1,
      customerId: values.client.value,
    },
    accessToken: localStorage.getItem("AccessToken") || "lll",
    url: protectedResources.apiTodoList.endpoint + `/jobs/${id}`,
  };
  dispatch(updateJob(requestParams)).then((r) => {
    if (r.payload) {
      dispatch(jobsGet(jobRequests)).then((r) => {
        if (r.payload.succeeded) {
          setIsLoading(false);
          addAlert("Job updated successfully", "success", true);
          navigate("/jobs");
        }
      });
    } else {
      setIsLoading(false);
      addAlert("Job updated Failed", "error", true);
      navigate("/jobs");
    }
  });
};
